import { useState, useEffect } from "react";
import { Button, Form, Input, notification, Select } from "antd";
import { useNavigate } from "react-router-dom";
import { get, post } from "../../../services";

const EventForm = () => {
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [adminData, setAdmins] = useState([]);
  // notification handler
  const openNotification = (message, description) => {
    notification.open({
      message: message,
      description: description,
    });
  };
  let options = [];
  // Method for API call
  const getAdmins = () => {
    get(`/user/getAllUsers?page=${1}&limit=${100}`)
      .then((response) => {
        response?.data?.users?.map((item) => {
          options.push({
            value: item?._id,
            label: item?.name,
          });
        });
        setAdmins(options);
        setLoader(false);
      })
      .catch((err) => {
        // to check token if token expired then logout user
        setLoader(false);
      });
  };

  // useEffect to get content
  useEffect(() => {
    getAdmins();
  }, []);

  // onFinish handler
  const onFinish = (values) => {
    // setLoader(true);
    let payload = {
      bankName: values?.bankName,
      accountNumber: values?.accountNumber,
      ifscCode: values?.ifscCode,
      branchName: values?.branchName,
    };
    post(`/user/bankdetails/${values?.user}`, payload)
      .then(() => {
        setLoader(false);
        navigate("/bank");
        openNotification("Success", "Bank Details Created Successfully");
      })
      .catch((error) => {
        setLoader(false);
        console.log("error", error);
        openNotification("Error", error?.response?.data?.message);
      });
  };

  return (
    <>
      <div className="header">
        <h3>Add Task</h3>
      </div>
      <div className="form_container">
        <Form layout="vertical" onFinish={onFinish}>
          {" "}
          <Form.Item
            className="w-full"
            name="user"
            direction="vertical"
            label="Employee"
            rules={[{ required: true, message: "Please select user" }]}
          >
            <Select
              name="user"
              allowClear
              style={{ width: "100%" }}
              placeholder="Please select"
              defaultValue={[]}
              options={adminData}
            />
          </Form.Item>
          <Form.Item
            name="bankName"
            label="Bank Name"
            rules={[{ required: true, message: "Please enter your Bank Name" }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="accountNumber"
            label="Account Number"
            rules={[
              { required: true, message: "Please enter your Account Number" },
            ]}
          >
            <Input type="text" />
          </Form.Item>
          <Form.Item
            name="ifscCode"
            label="Code"
            rules={[{ required: true, message: "Please enter your Code" }]}
          >
            <Input type="text" />
          </Form.Item>
          <Form.Item
            name="branchName"
            label="Branch Name"
            rules={[
              { required: true, message: "Please enter your Branch Name" },
            ]}
          >
            <Input type="text" />
          </Form.Item>
          <Form.Item>
            <div className="form_submit">
              <Button className="back_button" onClick={() => navigate("/bank")}>
                Back
              </Button>
              <Button htmlType="submit">{loader ? "wait..." : "Save"}</Button>
            </div>
          </Form.Item>
        </Form>
      </div>
    </>
  );
};
export default EventForm;
